import React from 'react';
import { useHistory } from 'react-router-dom';
import { FRESHDESK_URL } from '../../../const/routes';
import { makeStyles } from '@material-ui/core';
import { PRIMARY_COLOR } from '../../../const/color-const';
import { ReactComponent as Email } from '../../../assets/email.svg';
import RenderDesktop from '../../common/breakpoints/RenderDesktop';
import { useLocation } from 'react-router';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  widget: {
    right: 20,
    width: 60,
    height: 60,
    bottom: 20,
    fontSize: 16,
    display: 'flex',
    cursor: 'pointer',
    position: 'fixed',
    fontWeight: '500',
    borderRadius: '30px',
    alignItems: 'center',
    justifyContent: 'center',
    background: PRIMARY_COLOR,
    transition: 'bottom 200ms ease, opacity 600ms ease-in-out, box-shadow 200ms ease',
    boxShadow: '0px 0px 6px 6px rgba(0,0,0,0.1)',
    '& svg': {
      height: 34,
      width: 'auto',
      transition: 'transform 300ms ease-out',
    },
    '&:hover': {
      bottom: 24,
    },
    '&:active, &:focus': {
      bottom: 22,
      boxShadow: '0px 0px 7px 7px rgba(0,0,0,0.15)',
      '& svg': {
        transform: 'scale(1.1)',
      },
    },
  },
  hidden: {
    bottom: 0,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 1000ms ease-in-out, visibility 1000ms step-end, bottom 1000ms ease-in-out',
  },
  icon: {
    position: 'absolute',
  },
}));

const ContactWidget = () => {
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const isHidden = location.pathname === '/freshdesk/create' || location.pathname === '/login';
  
  const handleClick = () => {
    history.push(`${FRESHDESK_URL}/create`);
  };
  
  return (
    <RenderDesktop>
      <div className={classNames(classes.widget, { [classes.hidden]: isHidden })} onClick={handleClick}>
        <Email className={classNames(classes.icon)} />
      </div>
    </RenderDesktop>
  );
};

export default ContactWidget;